export default "<div id=\"rm_provenancemap_div\"></div>"